import { useEffect, useState } from 'react'
import { useSnapshot } from 'valtio'
import type { RadarConfig } from '../../../../types'
import { ContentSettings } from '../../components/settings/ContentSettings'
import { DataManagement } from '../../components/settings/DataManagement'
import { DisplaySettings } from '../../components/settings/DisplaySettings'
import { EmbedSettings } from '../../components/settings/EmbedSettings'
import { LogoSettings } from '../../components/settings/LogoSettings'
import { SettingsCard } from '../../components/settings/SettingsCard'
import { api } from '../../lib/api'
import { getRadarData, state } from '../../lib/state'
import { usePersistedConfig } from './usePersistedConfig'

const AdminSettingsPage = () => {
  const { radarConfig, availableRadars, currentRadarId } =
    useSnapshot(state)
  const [localConfig, setLocalConfig] = useState<RadarConfig | null>(null)
  const [version, setVersion] = useState<string>('')

  // Fetch radar data when currentRadarId changes
  useEffect(() => {
    if (currentRadarId) {
      getRadarData(currentRadarId)
    }
  }, [currentRadarId])

  // Initialize localConfig from radarConfig when it changes
  useEffect(() => {
    if (radarConfig) {
      setLocalConfig(JSON.parse(JSON.stringify(radarConfig)))
    }
  }, [radarConfig])

  // Fetch version number
  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const versionNumber = await api.getVersion()
        setVersion(versionNumber)
      } catch (error) {
        console.error('Failed to fetch version:', error)
        setVersion('')
      }
    }
    fetchVersion()
  }, [])

  const setConfig = usePersistedConfig(setLocalConfig)

  return (
    <div className="space-y-6 mt-6 pb-6" style={{ overflowY: 'auto' }}>
      {Array.isArray(availableRadars) && availableRadars?.length > 0 && (
        <SettingsCard>
          <div className="space-y-6">
            <DisplaySettings config={localConfig} setConfig={setConfig} />
            <ContentSettings config={localConfig} setConfig={setConfig} />
            <LogoSettings config={localConfig} setConfig={setConfig} />
            <EmbedSettings config={localConfig} setConfig={setConfig} />
          </div>
        </SettingsCard>
      )}

      <SettingsCard>
        <DataManagement />
      </SettingsCard>

      {/* Version number in lower right corner */}
      {version && (
        <div className="text-xs text-[var(--ds-text-subtle)] opacity-60">
          v{version}
        </div>
      )}
    </div>
  )
}

export default AdminSettingsPage
